import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import { deployRequest } from "@/model/request/entity/deployRequest";

export const deployApi = createApi({
    reducerPath: "deployApi",
    baseQuery: fetchBaseQuery({baseUrl:'https://3gtiecsm6jguvxl777ino6jdqa0vftld.lambda-url.us-east-1.on.aws'}),
    endpoints: (builder) => ({
        createRepo: builder.mutation<void, deployRequest>({
            query: (body) => ({url: "/repo/create-repo-with-appId", method: "POST", body}),
        }),
       
    }),
});


export const {useCreateRepoMutation} = deployApi;